/* ==========================================================================
   MDS · SHARED PRODUCT IMAGE URLS
   --------------------------------------------------------------------------
   THIS IS THE ONLY FILE YOU EDIT WHEN A PRODUCT IMAGE CHANGES.

   All 11 Move-In Ready pages and the residence finder read their images from
   here, so changing a URL below updates every page at once.

   HOW TO UPDATE AN IMAGE
   ----------------------
     1. Shopify Admin >  Content > Files   — find the image
     2. Click the copy-link icon to copy its URL
     3. Find the matching line below, paste the new URL between the quotes
     4. Save, then upload this file to
        Online Store > Themes > Edit code > Assets   (replace mds-images.js)

   Only change the URL. Keep the key name on the left exactly as it is —
   the pages look images up by that key.
   ========================================================================== */

window.MDS_IMG = {

    /* ---- Step 1 · Room essentials ---------------------------- */
    // Mattress Protector
    "mattress-protector": "https://mydormstore.ca/cdn/shop/files/mattress-protector-556663.png?v=1750881227",
    // Shower Curtain + Liner + Rings
    "shower-curtain": "https://mydormstore.ca/cdn/shop/files/shower-curtain-rings-7728888.png?v=1782151748",
    // Bath Mat
    "bath-mat": "https://mydormstore.ca/cdn/shop/files/bath-mat-5574810.png?v=1785466100",

    /* ---- Step 2 · Bedding bundles ---------------------------- */
    // Standard Bedding
    "bed-std": "https://mydormstore.ca/cdn/shop/files/standard-bedding-package-8427131.png?v=1779665888&width=823",
    // Deluxe Bedding — GREY (also the default)
    "bed-dlx-grey": "https://mydormstore.ca/cdn/shop/files/deluxe-bedding-package-1585394.png?v=1786294687",
    // Deluxe Bedding — BLUE
    "bed-dlx-blue": "https://mydormstore.ca/cdn/shop/files/deluxe-bedding-package-5477382.png?v=1786294687",
    // Mattress Topper
    "mattress-topper": "https://mydormstore.ca/cdn/shop/files/mattress-topper-9201277.png?v=1786294686",

    /* ---- Step 3 · Add-on bundles ----------------------------- */
    // Bathroom Essentials
    "bath": "https://mydormstore.ca/cdn/shop/files/bathroom-essentials-4156260.png?v=1785466100&width=990",
    // Laundry Essentials (delicates bag)
    "laundry": "https://cdn.shopify.com/s/files/1/0575/0934/7490/files/laundry-essentials-3359421.png?v=1775937307",
    // Laundry Essentials (large bag)
    "laundry-large": "https://mydormstore.ca/cdn/shop/files/laundry-essentials-3608974.png?v=1785466218",
    // Basic Kitchen Essentials
    "kitchen-basic": "https://mydormstore.ca/cdn/shop/files/basickitchen.png?v=1785395968",
    // Complete Kitchen Essentials
    "kitchen": "https://mydormstore.ca/cdn/shop/files/complete-kitchen-essentials-8787638.png?v=1785466090",
    // Tech Essentials
    "tech": "https://cdn.shopify.com/s/files/1/0575/0934/7490/files/tech-essentials-6073257.png?v=1776102907",
    // Power Bar
    "power-bar": "https://mydormstore.ca/cdn/shop/files/power-bar-4665605.png?v=1781903106&width=713",
    // Cleaning Essentials
    "cleaning": "https://cdn.shopify.com/s/files/1/0575/0934/7490/files/cleaning-essentials-8771296.png?v=1776046560",
    // Household Essentials
    "household": "https://mydormstore.ca/cdn/shop/files/household-essentials-8714260.png?v=1776848715&width=2048",
    // Organization Essentials
    "organization": "https://mydormstore.ca/cdn/shop/files/organization-essentials-8518699.png?v=1785714666",
    // Decoration Essentials
    "decor": "https://mydormstore.ca/cdn/shop/files/decoration-essentials-5337505.png?v=1779583025&width=2048",
    // Whiteboard and Decor
    "door-decor": "https://cdn.shopify.com/s/files/1/0575/0934/7490/files/door.png?v=1779576477",
    // Desk Lamp & Essentials
    "desk": "https://cdn.shopify.com/s/files/1/0575/0934/7490/files/desk-lamp-essentials-9226869.png?v=1776049740",

    /* ---- Step 4 · Popular picks ------------------------------ */
    // Plastic Hangers
    "pop-hangers-plastic": "https://mydormstore.ca/cdn/shop/files/hangers-5911429.png?v=1785631809",
    // Velvet Hangers
    "pop-hangers-velvet": "https://mydormstore.ca/cdn/shop/files/hangers-1412616.png?v=1785631809",
    // Tide Pods (16 PK)
    "pop-tide-pods": "https://mydormstore.ca/cdn/shop/files/tide-pods-9-pk-828151.png?v=1741724327&width=2048",
    // Extension Cord
    "pop-ext-cord": "https://cdn.shopify.com/s/files/1/0575/0934/7490/files/extension-cord-4533904.png?v=1781985972&width=2048",
    // Shower Caddy
    "pop-shower-caddy": "https://mydormstore.ca/cdn/shop/files/shower-caddy-8457031.png?v=1782068840",
    // Fan
    "pop-fan": "https://mydormstore.ca/cdn/shop/files/fan-899781.jpg?v=1741724334&width=2048",
    // Mesh Laundry Hamper
    "pop-mesh-hamper": "https://mydormstore.ca/cdn/shop/files/mesh-laundry-hamper-6934952.png?v=1782068839",
    // Mirror
    "pop-mirror": "https://mydormstore.ca/cdn/shop/files/mirror-9986457.png?v=1782068838",
    // Storage Bins
    "pop-storage-bins": "https://mydormstore.ca/cdn/shop/files/storage-bins-6307306.png?v=1782068839&width=990",
    // Folding Baskets — MEDIUM
    "pop-folding-baskets": "https://mydormstore.ca/cdn/shop/files/folding-storage-baskets-7106749.png?v=1782068838&width=990",
    // Folding Baskets — LARGE
    "pop-folding-baskets-lg": "https://mydormstore.ca/cdn/shop/files/folding-storage-baskets-1224883.png?v=1785631807&width=990",
    // Sheet Set
    "pop-sheet-set": "https://mydormstore.ca/cdn/shop/files/sheet-set-6899677.png?v=1782317467&width=2048",
    // Premium Pillows
    "pop-pillow": "https://mydormstore.ca/cdn/shop/files/premium-pillows-8252879.png?v=1782317467",
    // Laundry Bag
    "pop-laundry-bag": "https://mydormstore.ca/cdn/shop/files/laundrybag.png?v=1785616975&width=990",
    // Over-the-Door Hooks
    "pop-over-door-hooks": "https://mydormstore.ca/cdn/shop/files/over-the-door-hooks-4699398.png?v=1785881228",
    // 4-Tier Shoe Rack
    "pop-4tier-shoe-rack": "https://mydormstore.ca/cdn/shop/files/BootShelf.png?v=1785823204",
    // Waste Bin
    "pop-waste-bin": "https://mydormstore.ca/cdn/shop/files/waste-bin-5367152.png?v=1779583026",

    /* ---- Care packages --------------------------------------- */
    // Monthly Subscription
    "care-monthly": "https://mydormstore.ca/cdn/shop/files/thinking-of-you-care-package-2098392.png?v=1782317406&width=990",
    // Birthday Package
    "care-birthday": "https://mydormstore.ca/cdn/shop/files/birthday-care-package-7169757.png?v=1782317406",
    // Holiday Package
    "care-holiday": "https://mydormstore.ca/cdn/shop/files/holiday-seasonal-package-8154916.png?v=1782317468",
    // Exam & Midterm Care
    "care-exam": "https://mydormstore.ca/cdn/shop/files/exam-midterm-care-package-6192367.png?v=1782317408",
};